import type { DoneActorEvent } from 'xstate';
import type { GuardPredicate } from 'xstate/guards';
import type { CartContextType } from '~/features/cart/state-machine/context';
import type { CartResponseData } from '~/features/cart/state-machine/types';

export const guardHasAvailabilityOptions: GuardPredicate<
  CartContextType,
  DoneActorEvent<CartResponseData>,
  undefined,
  never
> = ({ event }) => {
  return event.output.positionAvailabilityOptions !== undefined && event.output.positionAvailabilityOptions.length > 0;
};
